import { Injectable } from '@angular/core';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from '../../assets/vfs/vfs_fonts';
pdfMake.vfs = pdfFonts;

/*
  Generated class for the DispLabelProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

/*
   Demo of params needed:

   'lang'         : 'en',
   'type'         : 'Day'
   'date'         : '2018-09-10',
   'pat_name'     : 'Leung Fei Fan'
*/


@Injectable()
export class DispLabelProvider {

   public pdfObj = null;


   /** ----- Constructor ----- **/

   constructor() {}


   /** ----- Public Methods ----- **/

   create = (inParams) => {

      return new Promise(resolve => {

         let content: any = [];
         for (let i = 0; i < inParams['admin'].length; i++) {
            if (inParams['admin'][i].length > 0) {
               let usage = [
                  {
                     table: {
                        widths: [30, 5, '*'],
                        body: [
                           [
                              { border: [false, false, false, false], text: (inParams['lang'] == 'en') ? 'NAME:' : '姓名:', style: 'itemTitle' },
                              { border: [false, false, false, false], text: '' },
                              { border: [false, false, false, false], text: '' + inParams['pat_name'], style: 'itemTitle' }
                           ]
                        ]
                     },
                     layout:
                     {
                        paddingLeft: function (i, node) { return null; },
                        paddingRight: function (i, node) { return null; },
                        paddingTop: function (i, node) { return null; },
                        paddingBottom: function (i, node) { return null; }
                     }
                  },
                  {
                     table: {
                        widths: [30, 5, '*'],
                        body: [
                           [
                              { border: [false, false, false, true], text: (inParams['lang'] == 'en') ? 'DATE:' : '日期:', style: 'itemTitle' },
                              { border: [false, false, false, true], text: '' },
                              { border: [false, false, false, true], text: '' + inParams['date'], style: 'itemTitle' }
                           ]
                        ]
                     },
                     layout:
                     {
                        paddingLeft: function (i, node) { return null; },
                        paddingRight: function (i, node) { return null; },
                        paddingTop: function (i, node) { return null; },
                        paddingBottom: function (i, node) { return 3; }
                     }
                  },
                  {
                     table: {
                        widths: [48, 5, '*'],
                        body: []
                     },
                     layout:
                     {
                        paddingLeft: function (i, node) { return null; },
                        paddingRight: function (i, node) { return null; },
                        paddingTop: function (i, node) { return 3; },
                        paddingBottom: function (i, node) { return null; }
                     }
                  }
               ];

               // Particular & Total
               let adminStr = '';
               for (let j = 0; j < inParams['admin'][i].length; j++) {
                  adminStr += inParams['admin'][i][j];
               }
               let contentStr = (inParams['lang'] == 'en') ? 'Administration:' : '服法:';
               let data = [
                  { border: [false, false, false, false], text: contentStr, style: 'itemContent' },
                  { border: [false, false, false, false], text: '' },
                  { border: [false, false, false, false], text: '' + adminStr, style: 'itemContent' }
               ];
               usage[2]['table']['body'].push(data);
               if (i > 0) usage[0]['pageBreak'] = "before";
               content.push(usage);
            }
         }

         var docDefinition =
         {
            content: content,
            styles:
            {
               itemTitle: {

                  fontSize: 9
               },
               itemContent: {

                  fontSize: 7
               }
            },
            defaultStyle: {
               font: 'Arial-Unicode-MS'
            },
            // defaultStyle: {
            //    font: 'Chinese'
            // },

            pageSize: 'C9',
            pageOrientation: 'landscape',
            pageMargins: [10, 10, 10, 10]
         };
         // setup fonts

        pdfMake.fonts = {
          "Chinese": {
            normal: 'wt011.ttf',
            bold: 'wt014.ttf'
          },
          'Arial-Unicode-MS': {
            normal: 'Arial-Unicode-MS.ttf',
            bold: 'Arial-Unicode-MS.ttf'
          }
        };

         // create PDF file
         this.pdfObj = pdfMake.createPdf(docDefinition);
         resolve();

      });
   }

}



// WEBPACK FOOTER //
// ./src/providers/disp-label/disp-label.ts